<template>
  <div class="activity-select">
    <im-select v-model="data" class="w-full" clearable size="small" placeholder="请选择活动" :options="activityList" :loading="loading" @input="onInput" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import ImSelect from '~/components/common/ImSelect.vue'

export default {
  components: { ImSelect },
  props: {
    type: [String, Number],
    value: [String, Number]
  },
  data() {
    return {
      activityList: [],
      loading: false,
      data: null
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo,
      projectId: (state) => state.project.projectId,
    }),
  },
  watch: {
    value(n) {
      this.data = n
    }
  },
  mounted() {
    this.init()
    this.data = this.value
  },
  methods: {
    init() {
      this.getActivityList()
    },
    onInput(value) {
      this.data = value
      this.$emit('input', value)
    },
    async getActivityList() {
      const now_stem = Math.floor(moment().utc().valueOf() / 1000)
      const params = {
        now_time: now_stem,
        activity_type: this.type,
        player_id: (this.userInfo && this.userInfo.uid || '').trim(),
        project_id: this.projectId || this.userInfo.project_id || '',
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList(params))
      this.loading = false
      if (!err) {
        const data = res?.list || []
        this.activityList = data.map(item => {
          return {
            label: item.name,
            value: item.biz_id
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
.activity-select {
  //
}
</style>
